import COMBaseRegulation from "../com_base_regulation";
import TimeSpan from "../../../../../utils/time_span";
import OptionsComponentController from "../../../../../components/options/options_component_controller";

export default class MaltaRegulation extends COMBaseRegulation {
  static CLASS = 'MaltaRegulation';

  protected realityCheckEnabled(): boolean {
    return true;
  }

  getRealityCheckInterval(): TimeSpan {
    return this.serviceFactory
        .componentFactoryService()
        .createComponent(OptionsComponentController)
        .getReminderInterval();
  }

  getRealityCheckIntervalExpectedByTheGame() {
    let interval = this.getRealityCheckInterval();
    return {
      timeSpan: interval,
      expectedValueByTheGame: Math.round(interval.totalSeconds),
    };
  }
}
